import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExecutionappIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 512,
	height: 512,
	viewBox: "0 0 512 512",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_45_8)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M216.5 510.7C188.4 506.4 164.1 498.7 138.5 485.95C116.95 475.15 99.8 463.6 81.15 447.1L77.5 443.9V465.2V486.5H56H34.5V425V363.5H96H157.5V385V406.5L130 406.6L102.5 406.75L108.8 412.5C143.75 444.35 186 463.6 233.5 469.35C238.95 470 244.65 470.2 256.25 470.25C272.95 470.25 279.9 469.65 292.75 467.2C296.35 466.5 300.75 465.8 302.55 465.65L305.85 465.4L306.1 466.8C306.25 467.6 308.2 476.45 310.45 486.45C312.7 496.45 314.5 505.2 314.4 505.95C314.25 507.1 313.9 507.3 309 508.35C306.1 508.95 300.15 510.05 295.7 510.75C287.7 512 287.6 512 255.95 511.95C225.25 511.9 224 511.85 216.5 510.7Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M363 416V354.5H384.5H406V382.4L406.05 410.25L409.85 406.25C436.3 378.2 454.1 346.15 463.55 309.6C471.4 279 472.5 247.9 466.7 216.65C466.05 213 465.5 209.2 465.5 208.15V206.25L483.9 202C494 199.7 503.4 197.7 504.8 197.6L507.35 197.4L508.7 204.35C511.75 220.5 511.65 218.35 511.85 252.85C512 279.9 511.95 285.95 511.25 291.1C509.25 307.05 504.95 325.65 499.95 340.35C488.2 374.8 470.95 404.4 447.6 430.4L443.9 434.5H464.95H486V456V477.5H424.5H363V416Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M200.35 291.6C168.45 259.7 166.5 257.65 166.5 256C166.5 254.35 167.5 253.25 180.4 240.35C193.25 227.5 194.4 226.5 196 226.5C197.65 226.5 199 227.75 216.85 245.6L236 264.75L275.15 225.6C312.05 188.7 314.35 186.5 316 186.5C317.65 186.5 318.75 187.5 331.65 200.4C344.5 213.25 345.5 214.4 345.5 216C345.5 217.65 342.55 220.7 291.6 271.65C240.65 322.6 237.65 325.5 236 325.5C234.35 325.5 232.3 323.55 200.35 291.6Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.8 314.1C4.35 313.35 1.95 299.95 1 292.7C0.1 286.15 0 282.3 0 255.55C0 228.1 0.1 225.2 1.05 218.75C6.85 179.15 20.9 142.4 42.65 109.75C48.7 100.7 55 92.5 63.35 82.85L68.05 77.5H47H26V56V34.5H87.5H149V96V157.5H127.5H106L105.9 129.65L105.75 101.8L99.95 108.25C86.35 123.35 76.95 136.4 68.55 151.9C54.6 177.45 46.3 204.1 42.65 234.75C42 240.35 41.8 245.9 41.8 256.5C41.85 271.95 42.7 281.4 45.25 295.1C45.95 298.9 46.5 302.85 46.5 303.9V305.8L41.4 306.95C38.55 307.55 30.2 309.5 22.85 311.3C10.3 314.3 5.4 315.05 4.8 314.1Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M354.9 142.6C354.8 139.35 354.8 129.8 354.9 121.35L355.1 106H382.65H410.2L408.25 103.95C407.15 102.85 403.8 99.7 400.75 97.05C373.35 72.8 342.45 56.6 306.15 47.55C277.8 40.45 243.55 39.65 215.8 45.45C213.05 46.05 209.85 46.5 208.7 46.5C206.85 46.5 206.5 46.35 206.25 45.35C200.1 19.45 198 9.70003 198 7.10003V4.75003L205.65 3.35003C222.6 0.20003 219.9 0.35003 253.95 0.15003C284.3 -0.0499701 286 2.98492e-05 293.2 1.00003C344.95 8.35003 390.95 29.55 429.9 63.95L434.5 68.05V47.05V26H456H477.5V87.25V148.5H416.3H355.1L354.9 142.6Z",
				fill: "currentColor"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_45_8",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 512,
			height: 512,
			fill: "white"
		})
	}) })]
});
export default SvgExecutionappIcon;
